import { format } from '../../../internal/utils/date';
export function formatDateValueToHTML(value) {
  if (value instanceof Date) {
    return format('yyyy-MM-dd', value);
  }
  if (typeof value === 'string') {
    return value;
  }
  return '';
}